export const DEZIIGN_SORTING_IDX= {
    // 1: 11,
    1: 19,
    // 2: 12
    2: 15,
    26: 26,
    20: 20,
    30: 15
}

export const SUPERPUPER_SORTING_IDX= {
    1: 1,
    2: 15,
    26: 26,
    20: 20,
}

export const HSE_SORTING_IDX = {
    1: 18,
    2: 15,
    26: 26,
    13: 13,
    20: 20,
    30: 15
}
export const LMS_SORTING_IDX = {
    1: 0,
    9: 2,
    10: 1,
    20: 0,
}

export const LMS_OFFLINE_SHOWCASE_IDX = {
    0: 0,
    3: 3,
    10: 1,
    9: 2
}
export const DEZIIGN_SORTING_IDX= {
    // 1: 11,
    1: 19,
    // 2: 12
    2: 15,
    26: 26,
    20: 20,
    30: 15
}

export const SUPERPUPER_SORTING_IDX= {
    1: 1,
    2: 15,
    26: 26,
    20: 20,
}

export const HSE_SORTING_IDX = {
    1: 18,
    2: 15,
    26: 26,
    13: 13,
    20: 20,
    30: 15
}
export const LMS_SORTING_IDX = {
    1: 0,
    9: 2,
    10: 1,
    20: 0,
}

export const LMS_OFFLINE_SHOWCASE_IDX = {
    0: 0,
    3: 3,
    10: 1,
    9: 2
}
